// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"r1-z","tooltip":"s1-z","tooltipContent":"t1-z","orderStatusWrapper":"u1-z"};